module.exports = __webpack_public_path__ + "img/black-circle.dc48f1c.svg";